export default "__VITE_ASSET__DKLKgNqr__"